import React from 'react';
import "./richTextBackGroundImg.css"
import BsyRadioGroup from "../../BsyRadioGroup";
import BsyMsgBubble from "../../../components/BsyMsgBubble";
import BsyComboBox from "../../../components/BsyComboBox";
import InputColor from 'react-input-color';
import 'color-selector-react/dist/es/index.css';
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import _ from "lodash";
import { BsyUtils } from "../../../utils/Utils";
class RichTextBackGroundImg extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bgData: props.richText.bgData || 'solidColor',
            richTextActiveColor: props.richText.richTextActiveColor || '',
            colorList: [{ color: 'rgb(166, 196, 223)', active: true }, { color: 'rgb(164, 181, 218)', active: false }, { color: 'rgb(162, 204, 212)', active: false }, { color: 'rgb(222, 169, 200)', active: false }, { color: 'rgb(226, 177, 159)', active: false }, { color: 'rgb(195, 195, 195)', active: false }, { color: 'rgb(80, 94, 107)', active: false }, { color: 'rgb(60, 97, 178)', active: false }, { color: 'rgb(31, 152, 176)', active: false }, { color: 'rgb(194, 106, 157)', active: false }, { color: 'rgb(51, 51, 51)', active: false }, { color: 'rgb(11, 46, 121)', active: false }, { color: 'rgb(33, 99, 112)', active: false }, { color: 'rgb(143, 56, 107)', active: false }, { color: 'rgb(153, 55, 20)', active: false }],
            okColorHooseList: props.richText.okColorHooseList || [],
            imgSetvalue: props.richText.imgSetvalue || 'stretchCenter',
            imgFile: props.richText.imgFile || {}
        };
        this.setSolidColorRef = null
    }

    emitChooseSolidColor = (val, okColorHooseList) => {
        this.setState({
            richTextActiveColor: val,
            okColorHooseList: okColorHooseList
        }, () => {
            this.onEmotemitSetRichData()
        })

    }
    onEmotemitSetRichData = () => {
        this.props.emitSetRichData({
            richTextActiveColor: this.state.richTextActiveColor,
            bgData: this.state.bgData,
            okColorHooseList: this.state.okColorHooseList,
            imgSetvalue: this.state.imgSetvalue,
            imgFile: this.state.imgFile
        })
    }
    setSolidColorFn = (event, type) => {
        if (!type) {
            this.setSolidColorRef = event.currentTarget
        }
        BsyMsgBubble({
            anchor: type ? this.setSolidColorRef : event.currentTarget,
            customCls: 't-type-one-dailog',
            contentHTML: () => {
                return (<DailogTypeSolidColor emitChooseSolidColor={this.emitChooseSolidColor} richTextActiveColor={this.state.richTextActiveColor} okColorHooseList={this.state.okColorHooseList}></DailogTypeSolidColor>)
            },
            text4Cancel: null,
            text4Ok: null,
            contentPadding: 0,
            edge: 200,
            dockPosition: "left",
            onClose: function () {
                return !1;
            }
        })

    }

    clearColorFn = (event) => {
        event.stopPropagation();
        event.preventDefault();
        this.setState({
            richTextActiveColor: ''
        }, () => {
            this.onEmotemitSetRichData()
        })

    }
    setSolidColorOrImg = (e) => {
        this.setState({
            bgData: e
        }, () => {
            this.onEmotemitSetRichData()
        })
    }
    changeImg = (param) => {

        const selectedFiles = Array.from(param.target.files);
        const maxSize = window.FX.STATIC.VIP_PACK.single_file; 
        if (selectedFiles[0].size > maxSize) {
            tipAlert({
                msg:  React.language("image.upload.size.rules.one",{count: window.FX.STATIC.VIP_PACK.single_file/1024/1024}),
                type: "warning",
              });
            return
        }
        const formData = new FormData();
        formData.append("file", selectedFiles[0]);
        formData.append(
            "x:uploader",
            window.FX.STATIC.user ? window.FX.STATIC.user._id : ""
        );
        React.axios("/dashboard/upload_workbenches_img", formData)
            .then((res) => {
                this.setState({
                    imgFile: res.data.file
                }, () => {
                    this.onEmotemitSetRichData()
                })

            })
            .catch((err) => {
                tipAlert({
                    type: "warning",
                    msg: err,
                });
            })
            .finally(() => { });
    }
    onChooseUpItem = (val) => {
        this.setState({
            imgSetvalue: val
        }, () => {
            this.onEmotemitSetRichData()
        })
    }
    deleteImgFileFn = () => {
        this.setState({
            imgFile: {}
        }, () => {
            this.onEmotemitSetRichData()
        })
    }
    render() {
        return <div className='rich-text-bg-page'>
            <BsyRadioGroup layout={"horizontal"} value={this.state.bgData}
                items={[
                    {
                        value: "solidColor",
                        text: React.language("form.theme.color"),
                    },
                    {
                        value: "img",
                        text: React.language("widget.image"),
                    },
                ]}
                onStopEdit={(e) => {
                    this.setSolidColorOrImg(e)
                }}
            />
            {
                this.state.bgData === 'solidColor' && <div className='selector-box'>
                    <div className='color-selector' onClick={this.setSolidColorFn} style={{ background: this.state.richTextActiveColor }}>
                        <span>{React.language("editer_button_set")}</span>
                        {
                            this.state.richTextActiveColor && this.state.richTextActiveColor !== "" && <div className='color-icon-wrapper' onClick={this.clearColorFn}><i className='icon-close-normal'></i></div>
                        }
                    </div>
                </div>
            }
            {
                this.state.bgData === 'img' && <div><div className="add-img-content">
                    {
                        _.isEmpty(this.state.imgFile) && <div className='upload-box'>
                            <div className='qr_upload'>
                                <div className='qsbtv'>
                                    <div>点击上传图片</div>
                                </div>
                            </div>
                            <div className='form-box'>
                                <form
                                    className="upload-form"
                                    action="/file/upload_des_img"
                                    method="post"
                                    multiple
                                >
                                    <input
                                        type="file"
                                        name="file"
                                        onChange={this.changeImg}
                                        className="upload-btn-input"
                                        accept=".jpg,.png,.jpeg,.gif"
                                    />
                                </form>
                            </div>
                        </div>
                    }

                    {!_.isEmpty(this.state.imgFile) && <div className={"img-box " + this.state.imgSetvalue}
                        style={{
                            backgroundImage:"url(" + (this.state.imgFile.previewUrl || BsyUtils.getfiledownloadURL(this.state.imgFile, {})) + ")"
                    
                        }}
                    >
                        <div className='del-btn' onClick={() => {
                            this.deleteImgFileFn()
                        }}>
                            <i className='icon-trasho'></i>
                        </div>
                    </div>}
                    <div className='editor-line'>
                        <div className='line-label'>{React.language("workbench.carouselMap.bg.title")}：</div>
                        <BsyComboBox ref={this.comboBoxRef}
                            baseCls='BsyComboBox t-rich-comb'
                            height={34}
                            items={
                                [{
                                    text: React.language("form.theme.imageMore.center"), value: "stretchCenter"
                                }, {
                                    text: React.language("form.theme.imageMore.centerCover"), value: "fillInCenter"
                                }, {
                                    text: React.language("form.theme.imageMore.stretchCover"), value: "masterDrawingCenter"
                                }]
                            }
                            width='auto'
                            searchable={false}
                            allowBlank={!1}
                            value={this.state.imgSetvalue}
                            onStopEdit={(t, sec, context) => {
                                this.onChooseUpItem(t, sec, context)
                            }}
                            onClose={(t) => {

                            }}
                        />
                    </div>
                    <div className='line-tip'>{React.language("image.maxLimitTip1", {
                        count: window.FX.STATIC.VIP_PACK.single_file/1024/1024,
                    })}</div>
                </div>
                </div>
            }

        </div>;
    }
}

export default RichTextBackGroundImg;

class DailogTypeSolidColor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bgData: 'solidColor',
            richTextActiveColor: props.richTextActiveColor || "",
            colorList: [{ color: 'rgb(166, 196, 223)', active: false }, { color: 'rgb(164, 181, 218)', active: false }, { color: 'rgb(162, 204, 212)', active: false }, { color: 'rgb(222, 169, 200)', active: false }, { color: 'rgb(226, 177, 159)', active: false }, { color: 'rgb(195, 195, 195)', active: false }, { color: 'rgb(80, 94, 107)', active: false }, { color: 'rgb(60, 97, 178)', active: false }, { color: 'rgb(31, 152, 176)', active: false }, { color: 'rgb(194, 106, 157)', active: false }, { color: 'rgb(51, 51, 51)', active: false }, { color: 'rgb(11, 46, 121)', active: false }, { color: 'rgb(33, 99, 112)', active: false }, { color: 'rgb(143, 56, 107)', active: false }, { color: 'rgb(153, 55, 20)', active: false }],
            okColorHooseList: props.okColorHooseList || [],
            imgSetvalue: 'rich1',
            activeTemporarilyColor: '',
            activeTemporarilyShow: false
        };
        this.setSolidColorRef = null
        this.inputColor = ''
    }
    chooseSolidColorFn = (item, key) => {
        let colorList = this.state.colorList
        colorList = colorList.map((obj, index) => {
            if (index === key) {
                return { ...obj, active: true };
            }
            return { ...obj, active: false };
        });
        let okColorHooseList = this.state.okColorHooseList
        okColorHooseList = okColorHooseList.map((obj, index) => {
            if (index === key) {
                return { ...obj, active: true };
            }
            return { ...obj, active: false };
        });


        this.setState({
            colorList: colorList,
            okColorHooseList: okColorHooseList,
            richTextActiveColor: item.color
        })
        this.inputColor = item.color
        this.props.emitChooseSolidColor(item.color, this.state.okColorHooseList)
    }
    emitInputColor = (val) => {
        this.inputColor = val
        this.setState({
            activeTemporarilyColor: val,
            activeTemporarilyShow: true
        })
    }
    closeInputColor = () => {

        let okColorHooseList = this.state.okColorHooseList
        okColorHooseList.unshift({ color: this.inputColor.rgba, active: false })
        this.setState({
            okColorHooseList: okColorHooseList,
            richTextActiveColor: this.inputColor.rgba,
            activeTemporarilyShow: false
        })
        this.props.emitChooseSolidColor(this.inputColor.rgba, okColorHooseList)
    }
    chooseInputColorFn(event) {
        let _this = this
        BsyMsgBubble({
            anchor: event.currentTarget,
            contentHTML: () => {
                return (<DailogTypeInputColor emitInputColor={this.emitInputColor} richTextActiveColor={this.state.richTextActiveColor}></DailogTypeInputColor>)
            },
            text4Cancel: null,
            text4Ok: null,
            contentPadding: 0,
            edge: 200,
            width: 290,
            dockPosition: "left",
            onClose: function () {
                _this.closeInputColor()
                return !1;
            }
        })
    }
    render() {
        return <div className='t-color-choose-page'>
            <div className='picker-wrapper'>
                <div className='color-label'>预设颜色</div>
                <div className='color-list preset-list'>
                    {
                        this.state.colorList.map((item, key) => {
                            return <div key={key} className='color-item' style={{ background: item.color }} onClick={() => {
                                this.chooseSolidColorFn(item, key)
                            }}>{this.state.richTextActiveColor === item.color && <i className='t-icon-choose icon-ok'></i>}</div>
                        })
                    }
                </div>
                <div className='color-label'>自定义颜色</div>
                <div className='color-list custom-list'>

                    <div className='add-btn-box color-item' onClick={(event) => { this.chooseInputColorFn(event) }}>
                        {!this.state.activeTemporarilyShow && <div className='add-btn'><i className='icon-add'></i></div>}
                        {this.state.activeTemporarilyShow && <div className='add-btn-box color-item 11' style={{ background: this.state.activeTemporarilyColor.rgba }}></div>}
                    </div>


                    {/* {this.state.activeTemporarilyShow && <div className='add-btn-box color-item 11' style={{ background: this.state.activeTemporarilyColor.rgba }}></div>} 选中颜色的时候临时给上 */}

                    {
                        this.state.okColorHooseList.filter((item, key) => { return key < 5 }).map((item, key) => {
                            return <div key={key} className='color-item' style={{ background: item.color }} onClick={() => {
                                this.chooseSolidColorFn(item, key)
                            }}>
                                {this.state.richTextActiveColor === item.color && <i className='t-icon-choose icon-ok'></i>}
                            </div>
                        })
                    }
                </div>

            </div>
        </div>
    }
}

class DailogTypeInputColor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bgData: 'solidColor',
            richTextActiveColor: "#ffffff",
            colorList: [{ color: 'rgb(166, 196, 223)', active: false }, { color: 'rgb(164, 181, 218)', active: false }, { color: 'rgb(162, 204, 212)', active: false }, { color: 'rgb(222, 169, 200)', active: false }, { color: 'rgb(226, 177, 159)', active: false }, { color: 'rgb(195, 195, 195)', active: false }, { color: 'rgb(80, 94, 107)', active: false }, { color: 'rgb(60, 97, 178)', active: false }, { color: 'rgb(31, 152, 176)', active: false }, { color: 'rgb(194, 106, 157)', active: false }, { color: 'rgb(51, 51, 51)', active: false }, { color: 'rgb(11, 46, 121)', active: false }, { color: 'rgb(33, 99, 112)', active: false }, { color: 'rgb(143, 56, 107)', active: false }, { color: 'rgb(153, 55, 20)', active: false }],
            okColorHooseList: [],
            pipetteList: ['#ffffff', '#A6C4DF', '#A4B5DA', '#A2CCD4', '#DEA9C8', '#E2B19F', '#C3C3C3', '#505E6B', '#505E6B', '#1F98B0', '#C26A9D', '#333333', '#0B2E79', '#216370', '#8F386B', '#993714'],
            pipetteLatestList: ['#D4D4D4', '#A6C4DF', '#A4B5DA', '#A2CCD4', '#DEA9C8', '#E2B19F', '#C3C3C3', '#505E6B', '#505E6B', '#1F98B0'],
            imgSetvalue: 'rich1',
        };
        this.setSolidColorRef = null
    }
    setColor = (val) => {
        this.props.emitInputColor(val)
        // this.props.emitInputColorTemporarily(val) //选择颜色单独给出事件处理
    }
    recommendedColor = (item) => {
        this.setState({
            richTextActiveColor: item
        })
        this.props.emitInputColor(item)
    }
    render() {
        return <div className='t-rich-pipette-color'>
            <div className='left'>
                <p className='title'>推荐颜色</p>
                <div className='recommend-box'>
                    {
                        this.state.pipetteList.map((item, key) => {
                            return <span key={key} className='color-item' style={{ background: item }} onClick={() => { this.recommendedColor(item) }}></span>
                        })
                    }
                </div>
                {/* <p className='title'>最近使用</p>
            <div className='recommend-box'>
                {
                    this.state.pipetteLatestList.filter((item, key) => { return key < 8 }).map((item, key) => {
                        return <span key={key} className='color-item' style={{ background: item }}></span>
                    })
                }
            </div> */}
            </div>
            <div className='right'>
                <p className='title'>自定义颜色</p>
                <InputColor className='t-input-color right'
                    initialValue={this.state.richTextActiveColor}
                    placement="left"
                    onChange={this.setColor}
                />
            </div>

        </div>
    }
}